(function (Drupal, once) {
  'use strict';

  const selector = '.page-header__authors-navigation';
  const cleanups = new WeakMap();

  Drupal.behaviors.authorsAlphabet = {
    attach(context) {
      const roots = [...context.querySelectorAll(selector)];
      if (context.matches?.(selector)) roots.unshift(context);
      once('authors-alphabet', roots).forEach((navigation) => {
        let frame;
        let focused = false;
        function reveal() {
          const active = navigation.querySelector('.views-summary a.is-active');
          if (!active || !navigation.clientWidth) return;
          const container = navigation.getBoundingClientRect();
          const link = active.getBoundingClientRect();
          const left = container.left + navigation.clientLeft;
          const right = left + navigation.clientWidth;
          if (link.left < left || link.right > right) {
            navigation.scrollLeft += link.left - left
              - (navigation.clientWidth - link.width) / 2;
          }
          if (!focused) {
            active.focus({preventScroll: true});
            focused = true;
          }
        }
        function schedule() {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(reveal);
        }
        const resize = new ResizeObserver(schedule);
        resize.observe(navigation);
        schedule();
        cleanups.set(navigation, () => {
          cancelAnimationFrame(frame);
          resize.disconnect();
        });
      });
    },
    detach(context, settings, trigger) {
      if (trigger !== 'unload') return;
      const roots = [...context.querySelectorAll(selector)];
      if (context.matches?.(selector)) roots.unshift(context);
      once.remove('authors-alphabet', roots).forEach((navigation) => {
        cleanups.get(navigation)?.();
        cleanups.delete(navigation);
      });
    },
  };
})(Drupal, once);
